import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import { STREAM_ROUTER_ROOT } from '../../constants';
import VideoOnDemandNew from './VideoOnDemandNew';
import {vodAction} from '../../../../../actions/vod';

// new way of actions. Has to have less memory in use;
let CRUDActions = vodAction;

export default connect(
  ({vod: {loadingItem}}) => ({
    title: 'Create Video on Demand',
    loading: loadingItem
  }),
  dispatch => ({
    fetch: () => dispatch(CRUDActions.createModel()),
    goIndex: () => dispatch(push(STREAM_ROUTER_ROOT))
  })
)(VideoOnDemandNew)





// WEBPACK FOOTER //
// ./src/components/Stream/CustomStream/Video/VideoOnDemandNew/index.js